var map = {
	"./clear-day.svg": "f40e",
	"./clear-night.svg": "1223",
	"./cloudy.svg": "47e9",
	"./fog.svg": "cb4d",
	"./hail.svg": "c1d3",
	"./partly-cloudy-day.svg": "683a",
	"./partly-cloudy-night.svg": "6925",
	"./rain.svg": "2622",
	"./sleet.svg": "7853",
	"./snow.svg": "ef28",
	"./thunderstorm.svg": "cdc8",
	"./tornado.svg": "8fc4",
	"./wind.svg": "247f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "84c1";